import {useFormStore} from '@stores/forms'
import {FIELD_CATEGORY_ENUM} from '@components/field-builder'

const protectedRoute = (role) => {
  return {
    requiresAuth: true,
    requiredRole: role || undefined
  }
}

export default [
  {
    path: '/spa/p',
    component: () => import('@layouts/ApplicationDataWrapper.vue'),
    meta: protectedRoute('partner'),
    children: [
      {
        name: 'partner-settings',
        path: 'settings',
        component: () => import('@pages/partner-settings.vue'),
        meta: {
          title: 'Team Settings',
          breadcrumb: {
            label: 'Settings',
            icon: 'settings',
          }
        },
      },
      {
        path: 'assets',
        meta: {
          title: 'Assets',
          breadcrumb: {
            label: 'Assets',
            icon: 'folder',
          }
        },
        children: [
          {
            name: 'partner-assets',
            path: '',
            component: () => import('@pages/partner/PartnerAssets.vue'),
            meta: { title: 'Assets' }
          },
          {
            name: 'asset-detail',
            path: 'asset-detail/:assetId',
            component: () => import('@pages/partner/AssetDetail.vue'),
            props: route => ({ assetId: Number(route.params.assetId) }),
            meta: {
              title: 'Asset Detail',
            },
          },
          {
            path: ':vendorId',
            name: 'partner-vendor-assets',
            meta: {
              title: 'Vendor\'s Assets',
              breadcrumb: {
                label: 'Vendor\'s Assets',
              }
            },
            component: () => import('@pages/partner/PartnerVendorAssets.vue'),
            children: [
              {
                name: 'asset-detail-DEPRECATED',
                path: 'asset-detail/:assetId',
                redirect: { name: 'asset-detail' },
              },
            ],
          },
        ],
      },
      {
        name: 'partner-deals',
        path: 'deals',
        component: () => import('@pages/partner/PartnerDealsPage.vue'),
        meta: {
          breadcrumb: {
            label: 'Deals',
            icon: 'valve',
            iconType: 'symbol',
          },
        },
      },
      {
        name: 'partner-announcements',
        path: 'announcements',
        component: () => import('@pages/partner/PartnerAnnouncements.vue'),
        meta: { title: 'Announcements', breadcrumb: { label: 'Announcements', icon: 'campaign' } }
      },
      {
        path: 'shared-info',
        meta: {
          breadcrumb: {
            label: 'Shared Info',
            icon: 'handshake'
          }
        },
        children: [
          {
            name: 'shared-info',
            path: '',
            component: () => import('@pages/partner/SharedInfo.vue'),
            beforeEnter: async(to, from) => {
              if (from.name === 'edit-shared-info' && to.query.requireRefresh) {
                await useFormStore().getAllForms({
                  page: -1,
                  category: FIELD_CATEGORY_ENUM.PARTNER_INFO,
                }, true)
              }
            },
            meta: {
              title: 'Shared Info',
            },
          },
          {
            name: 'edit-shared-info',
            path: 'edit/:formId',
            component: () => import('@pages/partner/EditSharedInfo.vue'),
            props: route => ({ id: Number(route.params.formId), formType: 'partner' }),
            meta: {
              title: 'Edit Shared Info',
              breadcrumb: {
                label: 'Edit Shared Info',
              }
            }
          },
        ],
      },
    ],
  },
]